import { motion } from "framer-motion";

export default function WeHaveYourBack() {
    return (
        <section
            id="commitment"
            data-testid="commitment-section"
            className="relative py-28 md:py-40 scratched-black grain overflow-hidden"
        >
            <div className="mx-auto max-w-5xl px-6 md:px-10 text-center relative">
                <motion.div
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="flex items-center justify-center gap-3 mb-6"
                >
                    <span className="h-px w-8 bg-gold" />
                    <span className="text-[10px] uppercase tracking-[0.4em] text-gold font-semibold">
                        06 / The Commitment
                    </span>
                    <span className="h-px w-8 bg-gold" />
                </motion.div>

                <motion.h2
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.8 }}
                    data-testid="commitment-headline"
                    className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight"
                >
                    We have{" "}
                    <span className="italic gold-gradient-text">
                        your back.
                    </span>
                </motion.h2>

                <p
                    data-testid="commitment-sub"
                    className="mt-10 text-cream/75 text-lg md:text-xl leading-relaxed max-w-3xl mx-auto"
                >
                    When you hire Nicholas Kraus Consulting, you're not just hiring a
                    consultant — you're gaining a team that is invested in your
                    success. From your first yard sign to{" "}
                    <span className="text-gold">Election Night</span>, we're with you
                    every step of the way.
                </p>

                <div className="mt-14 flex flex-wrap items-center justify-center gap-8 md:gap-14">
                    {[
                        "Smart strategy.",
                        "Strong grassroots.",
                        "Professional execution.",
                    ].map((t) => (
                        <div
                            key={t}
                            className="font-display italic text-2xl md:text-3xl text-cream/90"
                        >
                            {t}
                        </div>
                    ))}
                </div>

                <div className="mt-16">
                    <a
                        href="#contact"
                        data-testid="commitment-cta"
                        className="inline-flex items-center gap-3 bg-gold text-ink px-10 py-5 uppercase tracking-[0.18em] text-xs font-bold hover:bg-gold-light transition-colors"
                    >
                        Start the Conversation
                    </a>
                </div>
            </div>
        </section>
    );
}
